// extracted by mini-css-extract-plugin
export default {"cursor":"AnimatedCursor_cursor__6ipMX"};